import { useMutation } from "@tanstack/react-query";

import { useRequiredParams } from "../utils/url";
import { assetsApiRequest } from "../api/api-request";
import { ApiResponse } from "../api/api-response.model";
import { getModelName, Point, PointSetValue, PointType } from "./point.model";

// Mutations

export function useUpdatePointMutation() {
  const { companyId } = useRequiredParams({ companyId: "number" });
  return useMutation({
    mutationFn: (point: PointSetValue) =>
      updatePointValue({
        point,
        companyId,
      }),
    // TODO: onError
  });
}

// Mutators

async function updatePointValue(params: {
  point: PointSetValue;
  companyId: number;
}) {
  const { id, type, ...rest } = params.point;
  const query =
    type === PointType.TimeSchedule ? "?updateUserModifiedAt=false" : "";
  return assetsApiRequest
    .post<
      ApiResponse<Point>
    >(`analytics/companies/${params.companyId}/${getModelName(type)}/${id}/value${query}`, rest)
    .then((o) => o.data.data);
}
